<script>
import { VTextField } from 'vuetify/lib';
export default VTextField.extend({
  props: {
    dense: {
      default: true,
      type: [Boolean, String],
    },
    outlined: {
      default: true,
      type: [Boolean, String],
    },
  },
});
</script>
